var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 65,
    viewBox: "0 0 55 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.975 47.553c-10.633-10.656-10.633-27.932 0-38.588 10.633-10.656 27.872-10.656 38.505 0 10.633 10.655 10.633 27.932 0 38.588L31.59 62.474a6.162 6.162 0 01-8.728 0L7.975 47.554z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.114 32.544a2.938 2.938 0 11-5.876.008 2.938 2.938 0 015.876-.008v0zM41.182 32.544a2.938 2.938 0 11-5.877.008 2.938 2.938 0 015.877-.008v0z",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.322 32.547H19.114",
    stroke: "#fff",
    strokeWidth: 2.605
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.146 32.545h-.61a2.114 2.114 0 01-2.114-2.114v-3.383a2.114 2.114 0 011.646-2.093L17 23.877c.363-.078.699-.25.973-.5l4.876-4.398a2.139 2.139 0 011.41-.55h11.98a2.114 2.114 0 011.86 1.097l1.987 3.58c.237.421.61.75 1.057.933l1.579.641a2.114 2.114 0 011.317 1.966v3.77a2.114 2.114 0 01-2.114 2.115h-.775",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCar);
export default __webpack_public_path__ + "static/media/pin-car.0ba990af.svg";
export { ForwardRef as ReactComponent };